// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "OrganizationalChartModule-module--arrow-up-and-down--0196d";
export var blockContainer = "OrganizationalChartModule-module--blockContainer--2cb9a";
export var blockTitle = "OrganizationalChartModule-module--blockTitle--503cc";
export var contentContainer = "OrganizationalChartModule-module--contentContainer--1046c";
export var entitiesContainer = "OrganizationalChartModule-module--entitiesContainer--bbbc2";
export var imageContainer = "OrganizationalChartModule-module--imageContainer--5c4d3";
export var imageWrapper = "OrganizationalChartModule-module--imageWrapper--3d363";
export var linkedinContainer = "OrganizationalChartModule-module--linkedinContainer--15c2a";
export var linkedinIcon = "OrganizationalChartModule-module--linkedinIcon--c2ec2";
export var name = "OrganizationalChartModule-module--name--bb360";
export var oddContainer = "OrganizationalChartModule-module--oddContainer--9f4c4";
export var personContainer = "OrganizationalChartModule-module--personContainer--38235";
export var personWrapper = "OrganizationalChartModule-module--personWrapper--1fb30";
export var visuallyHidden = "OrganizationalChartModule-module--visuallyHidden--f8c39";
export var withPersonImage = "OrganizationalChartModule-module--withPersonImage--c9969";